module.exports = __webpack_public_path__ + "static/media/no-ready-groups-loads-white.dd610237.svg";